export default __webpack_public_path__ + "static/media/tayab-pabel.ecb5559d.jpeg";